import { EventEmitter } from '@angular/core';
var BaseVideoPlayerComponent = /** @class */ (function () {
    function BaseVideoPlayerComponent() {
        this.completed = new EventEmitter();
    }
    return BaseVideoPlayerComponent;
}());
export { BaseVideoPlayerComponent };
